/*
  Import Sentry's node or browser moudule depending on env

  Use process.env.BUILD_TARGET over @jetshop/core/inServer.
  
  When using `process.env.*` this is evaluated at compile time & only one
  of the lines will  transpiled into the final code.
*/
function errorReporting(error, extra) {
    let report;
    if (__IN_SERVER__) {
        report = require('./errorReporting.server').default;
    }
    else {
        report = require('./errorReporting.browser').default;
    }
    return report(error, extra);
}
export default errorReporting;
//# sourceMappingURL=errorReporting.js.map